import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { State } from '@dwo/reducers';
import { Store } from '@ngrx/store';

@Injectable()
export class DashboardEffect {
  constructor(
    readonly actions$: Actions,
    readonly store: Store<State>,
  ) {}

  // @Effect()
  // loadWorkOrders$: Observable<Action> = createEffect(() => this.actions$.pipe(
  //   ofType(
  //     DashboardActionTypes.AddToSearchText,
  //     DashboardActionTypes.SetSearchText,
  //     DashboardActionTypes.ClearSearchText,
  //   ),
  //   this.store.dispatch(new LoadWorkOrder())
  // ));
}
